/**
 * Custom Content Toggle Script - Simple Version
 */

const btnInfo = document.querySelector('.custom-benefits-informations .newsletter-form__title');
const targetSection = document.querySelector('#shopify-section-sections--24889213550915__blocks_KKLDEF');

if (btnInfo && targetSection) {
  // Set hidden first
  targetSection.style.display = 'none';
  
  // Click event
  btnInfo.addEventListener('click', function() {
    if (targetSection.style.display === 'none') {
      targetSection.style.display = 'block';
    } else {
      targetSection.style.display = 'none';
    }
  });
}